export default class Cookies {
    cookies;
    constructor() {
        this.cookies = this.getCookies();
    }
    getCookies() {
        return document.cookie.split("; ").reduce((a, c) => {
            let [n, v] = c.split("=");
            return { ...a, [n]: decodeURIComponent(v) };
        }, {});
    }
    has(key) {
        return Boolean(this.cookies[key]);
    }
    static getActualKey(key) {
        return encodeURIComponent(key)
            .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
            .replace(/[()]/g, escape);
    }
    static getActualValue(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
    get(key) {
        const actualKey = Cookies.getActualKey(key);
        return this.cookies[key] ?? this.cookies[actualKey] ?? "";
    }
    set(key, value) {
        const actualKey = Cookies.getActualKey(key);
        const actualValue = Cookies.getActualValue(value);
        this.cookies[actualKey] = actualValue;
        document.cookie += `${actualKey}=${actualValue}; `;
        return { actualKey, actualValue };
    }
}
//# sourceMappingURL=cookies.js.map